import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { BugReport, BugReportWithUser } from '../types';

export const bugReportLoaders = getLoaders({
  findBugReport: {
    load: async ({ reportId }: { reportId: string }): Promise<BugReportWithUser> => {
      return executeApiCall({
        path: `/feedback/bug-report/${reportId}`,

        method: 'get',
      });
    },
  },

  openBugReports: {
    load: async (): Promise<BugReportWithUser[]> => {
      return executeApiCall({
        path: `/feedback/bug-report/active`,

        method: 'get',
      });
    },
  },

  myContextNeededReports: {
    load: async (): Promise<BugReport[]> => {
      return executeApiCall({
        path: `/feedback/bug-report/needs-context`,

        method: 'get',
      });
    },
  },
});
